'use client';

import React, { useState } from 'react';
import projectsData from './projects.data';
import './Projects.css';

import Link from 'next/link';
import TitleMain from '@/components/shared/TitleMain/TitleMain';
import MarqueeComponent from '@/components/UI/Marquee';

const Projects = () => {
  const [modalData, setModalData] = useState(null);

  return (
    <div
      id='Projects'
      className='bg-gradient-to-b from-purple-800 via-blue-800 to-purple-800 backdrop-blur-md pb-10  md:pb-30 pt-20 '
    >
      <TitleMain text={'My Projects'} className='text-purple-700' />
      <div className='projects-container'>
        {projectsData
          .filter(project => project.show === 'on') // Only show projects with "show: 'on'"
          .slice(0, 6) // Limit to 6 projects
          .map((project, index) => (
            <div key={index} className='project-card'>
              {/* Project Image */}
              <div
                className='image-container '
                style={{ backgroundImage: `url(${project.image})` }}
              >
                <div className='background-image'></div>
              </div>

              {/* Card Content */}
              <div className='card-content'>
                <h3 className='project-title'>{project.name}</h3>
                <p className='project-meta'>
                  {project.category} | {project.stack}
                </p>

                {/* Technologies */}
                <div className='technologies flex flex-wrap gap-2 mb-6'>
                  {project.technologies.slice(0, 4).map((tech, i) => (
                    <span
                      key={i}
                      className='technology text-xs font-mono px-2 py-1 rounded-full bg-blue-900/30'
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className='mt-auto flex flex-col sm:flex-row gap-3'>
                  <Link
                    href={project?.liveURL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='flex-1'
                  >
                    <div className='text-white text-center border border-purple-400 px-4 py-2 rounded-xl hover:bg-purple-400/10 transition-colors duration-200'>
                      Visit Live
                    </div>
                  </Link>

                  <Link href={`/project/${project.id}`} className='flex-1'>
                    <div className='text-white text-center border border-blue-400 px-4 py-2 rounded-xl hover:bg-blue-400/10 transition-colors duration-200'>
                      Details
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          ))}
      </div>

      <MarqueeComponent text='Currently, I am in the process of updating all of my existing projects. As a result, some projects are not available at the moment. However, I will be adding them here soon. Thank you.' />
    </div>
  );
};

export default Projects;
